import { AdminChatInterface } from '@/components/chat/AdminChatInterface';

export default function AdminChat() {
  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">Admin Chat Interface</h1>
      <AdminChatInterface />
    </div>
  );
}
